import { fromRenderProps } from 'recompose';
import { NotificationsConsumer } from './NotificationsContext';

// Pull the Notifications client out of the NotificationsContext and map it to the client prop
// Everything below this will have the client available to it for options
const withNotificationsClient = fromRenderProps(NotificationsConsumer, ({ client }) => ({ client }));

export default withNotificationsClient;
